exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".desafios-semanales:nth-child(2) .col-12>[class^=col][data-v-51843fea]{padding-top:0!important}.desafios-semanales:last-child .col-12>[class^=col][data-v-51843fea]{border:0!important;padding-bottom:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-51843fea","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ps-consultor-externo-lideresasignados.vue
// module id = YBA7
// module chunks = 1